/* unplugin-vue-components disabled */import { render } from "./pulse-search.vue?vue&type=template&id=6a9c1a22"
import script from "./pulse-search.vue?vue&type=script&lang=js"
export * from "./pulse-search.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pulse/pulse-search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a9c1a22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a9c1a22', __exports__)) {
    api.reload('6a9c1a22', __exports__)
  }
  
  module.hot.accept("./pulse-search.vue?vue&type=template&id=6a9c1a22", () => {
    api.rerender('6a9c1a22', render)
  })

}


export default __exports__